
import ReviewCard from "./ReviewCard.vue";
import ReviewModal from "./ReviewModal.vue";
import ReviewsHeader from "./ReviewsHeader.vue";
import UiSwiperCarousel from "~/components/UI/UiSwiperCarousel.vue";

export default {
  name: "ProductReviews",
  components: {
    UiSwiperCarousel,
    ReviewCard,
    ReviewModal,
    ReviewsHeader,
  },
  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isReviewPopupOpen: false,
      selectedReview: null,
    };
  },
  computed: {
    reviewsList() {
      return this.reviews?.length ? this.reviews : [];
    },
    selectedReviewTitle() {
      return this.selectedReview
        ? this.getReviewTitle(this.selectedReview)
        : "";
    },
    selectedReviewDescription() {
      return this.selectedReview
        ? this.getReviewDescription(this.selectedReview)
        : "";
    },
    selectedReviewMediaList() {
      return this.selectedReview?.medias || [];
    },
    reviewsBreakpoints() {
      return {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 8,
          resistanceRatio: this.reviewsList.length > 2.5 ? 0.85 : 0,
        },
        992: {
          slidesPerView: 3.5,
          spaceBetween: 16,
          resistanceRatio: this.reviewsList.length > 3.5 ? 0.85 : 0,
        },
        1200: {
          slidesPerView: 4.5,
          spaceBetween: 16,
          resistanceRatio: this.reviewsList.length > 4.5 ? 0.85 : 0,
        },
      };
    },
  },
  methods: {
    getReviewTranslation(review) {
      return review?.mixedTranslation || review?.translations?.[0] || {};
    },
    getReviewTitle(review) {
      const translation = this.getReviewTranslation(review);
      return translation?.subtitle || translation?.title || "";
    },
    getReviewDescription(review) {
      const translation = this.getReviewTranslation(review);
      const description = translation?.description || "";
      return description
        .replace(/<(p|div|h[1-6]|section|article)[^>]*>/gi, "")
        .replace(/<\/(p|div|h[1-6]|section|article)>/gi, " ")
        .replace(/\s+/g, " ")
        .trim();
    },
    getReviewImageUrl(review) {
      const firstMedia = review?.medias?.[0];
      return firstMedia?.file?.url || firstMedia?.url || "";
    },
    getReviewImageAlt(review) {
      const firstMedia = review?.medias?.[0];
      return firstMedia?.alt || "";
    },
    openReviewPopup(review) {
      this.selectedReview = review;
      this.isReviewPopupOpen = true;
    },
    closeReviewPopup() {
      this.isReviewPopupOpen = false;
      this.selectedReview = null;
    },
  },
};
